// extracted by mini-css-extract-plugin
export var autoExpand = "_2c-8";
export var container = "_2c-7";
export var containerWidth = "_2c-5";
export var disabled = "_2c-2";
export var error = "_2c-3";
export var fullWidth = "_2c-6";
export var inputWrapper = "_2c-0";
export var small = "_2c-1";
export var textarea = "_2c-4";